<script>
import helper from "@/components/Utility/Helper"

let loadData = async function(context, feedback, url, cacheParameter, callback) {
  context.$refs["pageFeedback"].setFeedbackLoading("Loading " + feedback);
  return await context.$http
    .get(url, helper.createAxiosConfig())
    .then(response => {
      let resultMeta = helper.processAxiosResponse(this, response, true);
      context.$refs["pageFeedback"].setFeedbackMessage();

      if(cacheParameter) {
        context[cacheParameter] = response.data;
      }

      if (!response.data || response.data.length === 0) {
        context.$refs["pageFeedback"].setFeedbackError("No " + feedback + " available.");
      }

      if(typeof callback === 'function') {
        return callback(response.data);
      }

      if (response.data && response.data.length > 0) {
        return response.data;
      }
    })
    .catch(error => {
      context.$refs["pageFeedback"].setFeedbackError(
        helper.parseAxiosErrorMessage(this, error, "loading", feedback)
      );
    })
}

let loadInitial = async function(context) {
  if(!(await loadData(context, 'staff data', helper.SERVER_URL + '/api2/personnel/', 'pageStaff'))) {
    return;
  }
  if(!(await loadData(context, 'car park data', helper.SERVER_URL + '/api2/carpark/', 'pageCarpark'))) {
    return;
  }
  if(!(await loadData(context, 'customer data', helper.SERVER_URL + '/api2/customer/', 'pageCustomer'))) {
    return;
  }
  if(!(await loadData(context, 'passcard type data', helper.SERVER_URL + '/api2/passtype/', 'pagePasstype'))) {
    return;
  }
  return true;
};

let loadCarparkRelated = async function(context, carparkFilter) {
  if(carparkFilter) {
    carparkFilter = '/carpark/' + carparkFilter;
  } else {
    carparkFilter = '';
  }

  if(!(await loadData(context, 'parking license data', helper.SERVER_URL + '/api2' + carparkFilter + '/license/', 'pageLicense'))) {
    return;
  }
  if(!(await loadData(context, 'zone data', helper.SERVER_URL + '/api2' + carparkFilter + '/zone/', 'pageZone'))) {
    return;
  }
  if(!(await loadData(context, 'passcard data', helper.SERVER_URL + '/api2' + carparkFilter + '/passcard/', 'pagePasscard'))) {
    return;
  }
  if(!(await loadData(context, 'product data', helper.SERVER_URL + '/api2' + carparkFilter + '/season/', 'pageSeason'))) {
    return;
  }
  return true;
}

let loadCustomerRelated = async function(context, customerFilter) {
  if(customerFilter) {
    customerFilter = '/customer/' + customerFilter;
  } else {
    customerFilter = '';
  }

  if(!(await loadData(context, 'parker data', helper.SERVER_URL + '/api2' + customerFilter + '/parker/', 'pageParker'))) {
    return;
  }
  return true;
}

let loadLeaseRelated = async function(context, leases) {
  for(let lease of leases) {
    context['pageFees'] = context['pageFees'] ? context['pageFees'] : {};
    if(context['pageFees'][lease['seasonID']]) {
      continue;
    }

    let feedback = 'season fees data';
    let seasonFees = await loadData(
      context, 
      feedback, 
      helper.SERVER_URL + '/api2/season/' + lease['seasonID'] + '/seasonFees/', 
      null);
    
    if(!seasonFees || seasonFees.length === 0) {
      context.$refs['pageFeedback'].setFeedbackError('No ' + feedback + ' available.');
      return;
    }

    if(!(context['pageFees'][lease['seasonID']] = seasonFees.find(k => k.isActive))) {
      context.$refs['pageFeedback'].setFeedbackError('No active ' + feedback + ' available.');
      return;
    }
  }

  return true;
}

export default {
  loadData,
  loadInitial,
  loadCarparkRelated,
  loadCustomerRelated,
  loadLeaseRelated,
};
</script>


// WEBPACK FOOTER //
// src/components/Utility/Loader.vue